var _style, _metadata, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _script;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProjectPlan(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 62.8 54.8",
    style: {
      enableBackground: "new 0 0 62.8 54.8"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n        .st0{fill:#185C37;}\n        .st1{fill:#33C481;}\n        .st2{fill:#21A366;}\n        .st3{opacity:0.1;enable-background:new ;}\n        .st4{opacity:0.2;enable-background:new ;}\n        .st5{fill:url(#SVGID_1_);}\n        .st6{fill:#FFFFFF;}\n    ")), _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, /*#__PURE__*/React.createElement("sfw", {
    xmlns: "http://ns.adobe.com/SaveForWeb/1.0/"
  }, /*#__PURE__*/React.createElement("slices", null), /*#__PURE__*/React.createElement("sliceSourceBounds", {
    height: 54.8,
    width: 62.8,
    x: 0.5,
    y: 4.6
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M60.1,54.8H24.4c-1.5,0-2.7-1.2-2.7-2.7V36.5l13.7-6.8l17.1,6.8h7.6c1.5,0,2.7,1.2,2.7,2.7v12.9  C62.8,53.6,61.6,54.8,60.1,54.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M42.2,18.3l-16,5.7L8,18.3V2.7C8,1.2,9.2,0,10.7,0h28.9c1.5,0,2.7,1.2,2.7,2.7L42.2,18.3L42.2,18.3z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M8,18.3h41.8c1.5,0,2.7,1.2,2.7,2.7v15.6H10.7c-1.5,0-2.7-1.2-2.7-2.7V18.3z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M21.7,46.8h8.7c1.3,0,2.4-0.9,2.6-2.2V14.1c0-1.5-1.2-2.7-2.6-2.7H8v22.4c0,1.5,1.2,2.7,2.7,2.7h11V46.8z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M30.4,45.7c2.1,0,3.8-1.7,3.8-3.8V14.1c0-2.1-1.7-3.8-3.8-3.8H8v23.6c0,1.5,1.2,2.7,2.7,2.7h11v9.1  C21.7,45.7,30.4,45.7,30.4,45.7z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M30.4,44.5c1.5,0,2.7-1.2,2.7-2.6V14.1c0-1.5-1.2-2.7-2.6-2.7H8v22.4c0,1.5,1.2,2.7,2.7,2.7h11v8  C21.7,44.5,30.4,44.5,30.4,44.5z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M29.3,44.5c1.5,0,2.7-1.2,2.7-2.6V14.1c0-1.5-1.2-2.7-2.6-2.7H8v22.4c0,1.5,1.2,2.7,2.7,2.7h11v8  C21.7,44.5,29.3,44.5,29.3,44.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 5.5643,
    y1: 2105.324,
    x2: 26.4033,
    y2: 2141.4199,
    gradientTransform: "matrix(1 0 0 1 0 -2096)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#18884F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#117E43"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0B6631"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M2.7,11.4h26.6c1.5,0,2.7,1.2,2.7,2.7v26.6c0,1.5-1.2,2.7-2.7,2.7H2.7c-1.5,0-2.7-1.2-2.7-2.7V14.1  C0,12.6,1.2,11.4,2.7,11.4z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M16.5,18.5c1.7-0.1,3.4,0.4,4.7,1.4c1.1,1.1,1.7,2.6,1.6,4.1c0,1.1-0.3,2.1-0.8,3.1c-0.6,0.9-1.4,1.6-2.3,2.1  c-1.1,0.5-2.3,0.8-3.5,0.7h-3.3v6.3H9.5V18.5H16.5z M13,27.2h2.9c0.9,0.1,1.8-0.2,2.6-0.8c0.6-0.6,0.9-1.4,0.9-2.3  c0-2-1.1-2.9-3.3-2.9h-3C13.1,21.2,13,27.2,13,27.2z"
  })), _script || (_script = /*#__PURE__*/React.createElement("script", {
    xmlns: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectPlan);
export default __webpack_public_path__ + "static/media/ProjectPlan.c9ef7ea4173c994621a16fce900de2ef.svg";
export { ForwardRef as ReactComponent };